var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import config from 'shared/config';
import { isDev } from 'shared/logic';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import { createUploadLink } from 'apollo-upload-client';
var apolloClient = new ApolloClient({
    link: ApolloLink.from([
        onError(function (_a) {
            var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
            if (graphQLErrors)
                graphQLErrors.map(function (_a) {
                    var message = _a.message, locations = _a.locations, path = _a.path;
                    return console.log("[GraphQL error]: Message: " + message + ", Location: " + locations + ", Path: " + path);
                });
            if (networkError)
                console.log("[Network error]: " + networkError);
        }),
        setContext(function (_, _a) {
            var headers = _a.headers;
            var token = localStorage.getItem('token');
            return {
                headers: __assign({}, headers, { authorization: token ? "Bearer " + token : '' })
            };
        }).concat(createUploadLink({
            uri: (isDev ? config.protocol + "://" + config.host + ":" + config.port : '') + "/graphql",
            credentials: 'same-origin',
        }))
    ]),
    cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
    connectToDevTools: true,
});
export { apolloClient };
